import { logger } from '@tunasong/models'

export const subscribeUser = async (publicKey: string): Promise<PushSubscription | null> => {
  const reg = await navigator.serviceWorker.ready

  if (!(reg.pushManager && 'subscribe' in reg.pushManager)) {
    logger.warn(
      'Push manager does not not exist, or do not have a subscribe method. For iOS, the app must be installed on the home screen to get the push manager.',
      reg
    )
    return null
  }

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: publicKey,
  })
  return sub
}
